import sx from '@styled-system/css';
import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';
import Base, { ButtonProps } from './base';
import { DISABLED_COLOR } from './shared';

type GhostButtonVariants = 'default' | 'primary' | 'alt' | 'light';

const Ghost = styled(Base, { shouldForwardProp })<
  ButtonProps<GhostButtonVariants>
>(
  ({ disabled = false }) =>
    sx({
      backgroundColor: 'transparent',
      boxShadow: 'inset 0 0 0 1px currentColor',
      '&[disabled]': {
        cursor: 'not-allowed',
        color: DISABLED_COLOR,
        '&:hover': {
          color: DISABLED_COLOR,
        },
        '&:active': {
          color: DISABLED_COLOR,
        },
      },
      ...(disabled && {
        cursor: 'not-allowed',
        color: DISABLED_COLOR,
        backgroundColor: 'transparent !important',
        '&:hover': {
          color: DISABLED_COLOR,
          backgroundColor: 'transparent !important',
        },
        '&:active': {
          color: DISABLED_COLOR,
          backgroundColor: 'transparent !important',
        },
      }),
    }),
  variant({
    variants: {
      default: {
        color: 'gray.0',
        '&:hover': {
          backgroundColor: 'gray.6',
        },
        '&:active': {
          backgroundColor: 'gray.5',
        },
      },
      primary: {
        color: 'indigo.3',
        backgroundColor: 'gray.7',
        '&:hover': {
          color: 'indigo.1',
          backgroundColor: 'indigo.7',
        },
        '&:active': {
          color: 'indigo.1',
          backgroundColor: 'indigo.6',
        },
      },
      alt: {
        color: 'gray.2',
        backgroundColor: 'gray.7',
        '&:hover': {
          color: 'gray.1',
          backgroundColor: 'gray.6',
        },
        '&:active': {
          color: 'gray.1',
          backgroundColor: 'gray.5',
        },
      },
      light: {
        color: 'gray.7',
        '&:hover': {
          color: 'gray.3',
        },
        '&:active': {
          color: 'gray.2',
        },
      },
    },
  }),
);

Ghost.defaultProps = {
  size: 'md',
  variant: 'default',
  disabled: false,
};

Ghost.displayName = 'Monterey(Button.Ghost)';
export default Ghost;
